import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'ui/layout/Modal'
import { Button, Paper } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Text2 } from 'ui/shorthands/Texts'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    width: 320,
  },
  message: {
    color: theme.palette.text.primary,
    paddingTop: theme.spacing(0.5),
    display: 'block',
  },
  buttons: {
    marginTop: theme.spacing(4),
    display: 'flex',
    placeContent: 'flex-end',
  },
  button: {
    height: 24,
    minWidth: 64,
    fontWeight: 500,
  },
}))

type ConfirmDiscardModalProps = {
  open: boolean
  onCancel: () => void
  onDiscard: () => void
}

// TODO: ConfirmContentを使ったものに書き換える
const ConfirmDiscardModal: React.FC<ConfirmDiscardModalProps> = ({
  open,
  onCancel,
  onDiscard,
}: ConfirmDiscardModalProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  return (
    <Modal open={open} handleClose={() => {}}>
      <Paper className={classes.root}>
        <Text2 className={classes.message}>
          {t('編集内容が破棄されます。よろしいですか？')}
        </Text2>
        <div className={classes.buttons}>
          <Button className={classes.button} onClick={onCancel} color="primary">
            {t('キャンセル')}
          </Button>
          <Button
            className={classes.button}
            onClick={onDiscard}
            color="primary"
          >
            {t('破棄する')}
          </Button>
        </div>
      </Paper>
    </Modal>
  )
}
export default ConfirmDiscardModal
